import React from 'react';
import { ModelDropdown } from './ModelDropdown';
import type { Model } from '../types';

export interface ComparisonModelSelectorProps {
  models: Model[];
  selectedModelIds: [string, string];
  onSelectModel: (index: 0 | 1, modelId: string) => void;
  disabled?: boolean;
}

export const ComparisonModelSelector: React.FC<ComparisonModelSelectorProps> = ({
  models,
  selectedModelIds,
  onSelectModel,
  disabled,
}) => {
  const modelA = models.find((m) => m.id === selectedModelIds[0]) || null;
  const modelB = models.find((m) => m.id === selectedModelIds[1]) || null;

  return (
    <div className="flex items-center gap-2">
      <ModelDropdown
        models={models}
        currentModel={modelA}
        onSelect={(id) => onSelectModel(0, id)}
        disabled={disabled}
      />
      <span className="text-sm font-bold text-purple-500 dark:text-purple-400 select-none">
        vs
      </span>
      <ModelDropdown
        models={models}
        currentModel={modelB}
        onSelect={(id) => onSelectModel(1, id)}
        disabled={disabled}
      />
    </div>
  );
};
